import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

// https://docs.google.com/spreadsheets/d/1oxESW-0Ne7WtP7gKejV6CJYSv-Q9ssFDC8MY1_chDT0

export enum EPromoAction {
    SHOW = 'show',
    CLICK = 'click'
}

interface IShowPromo {
    action: EPromoAction.SHOW;
    /* В каком разделе показали плашку */
    source: EStorageType;
    /* Название плашки */
    name: 'disable-adv' | 'disable-adv-button';
}

interface IClickPromo {
    action: EPromoAction.CLICK,
    source: EStorageType;
    name: 'disable-adv' | 'disable-adv-button';
    /* Название кнопки/ссылки на которую нажали */
    name_button: 'disable-adv';
}

type IPromoAnalytics = IShowPromo | IClickPromo;

export const sendPromoAnalytics = ({ action, ...rest }: IPromoAnalytics): void => {
    sendDwh({ 
        eventCategory: ECategoryGa.splashscreen_alert, 
        action, 
        dwhData: rest,
    });
};